import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating';
import { translate, imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/TranslationsProvider';
import Tabs from '../../../gatsby-core-theme/hooks/tabs';

import ProviderTabs from '../providers-tabs';
import styles from './provider.module.scss';

const Providers = ({ pageContext, isStorybook = false }) => {
  const { page } = pageContext;
  const sport = page?.relation?.sport;
  const data = Object.keys(page?.relation?.providers).map((key) => page?.relation?.providers[key]);
  const { translations } = useContext(Context) || {};
  return (
    <div className={styles.providerTabsContainer}>
      <h3 className={`${styles.providerTitle} ${styles[sport?.name]}`}>
        {translate(translations, 'sponsored_content', 'Sponsored content')} -{' '}
        {translate(translations, 'streaming_provider', 'Find your live streaming provider')}
      </h3>
      <Tabs tabsAlign="left" type="providers" sport={sport?.name} gtmClass="providers-tabs-gtm">
        {data.map((item) => (
          <div
            key={item.id}
            label={item.name}
            content={
              <div>
                <div>
                  <LazyImage
                    src={imagePrettyUrl(item?.rectangle_logo)}
                    alt={item.name}
                    width={70}
                    height={35}
                  />
                </div>
                <StarRating numOfStars={5} rating={item.rating} />
                <div>
                  <p>{item.price || '-'}</p>
                </div>
              </div>
            }
          >
            <ProviderTabs pageContext={pageContext} provider={item} isStorybook={isStorybook} />
          </div>
        ))}
      </Tabs>
    </div>
  );
};

Providers.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({
        sport: PropTypes.shape({}),
        providers: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }).isRequired,
  }).isRequired,
  isStorybook: PropTypes.bool,
};

export default Providers;
